export const requestCanceller = () => {
	const controller = new AbortController();
	return {
		cancel : () => controller.abort(),
		signal : controller.signal,

	};
}